import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createSlots as _createSlots, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "time-card-container text-gray-333 mb-20" }
const _hoisted_2 = { class: "flex items-center mb-4 mt-8" }
const _hoisted_3 = { class: "time-card mr-4" }
const _hoisted_4 = { style: {"font-weight":"normal"} }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "mx-2" }, "〜", -1)
const _hoisted_6 = { style: {"font-weight":"normal"} }
const _hoisted_7 = { class: "mr-3 font-bold font-size-14 whitespace-no-wrap" }
const _hoisted_8 = { class: "show-setting mb-4 mt-4 flex items-center" }
const _hoisted_9 = { class: "text-center dropdown-card" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = { class: "text-center" }
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = { class: "text-center" }
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = { class: "text-center" }
const _hoisted_31 = { class: "text-center" }
const _hoisted_32 = { class: "text-center" }
const _hoisted_33 = { class: "text-center" }
const _hoisted_34 = { class: "text-center" }
const _hoisted_35 = { class: "text-center" }
const _hoisted_36 = { class: "text-center" }
const _hoisted_37 = { class: "text-center" }
const _hoisted_38 = { class: "text-center" }
const _hoisted_39 = { class: "text-center" }
const _hoisted_40 = { class: "text-center" }
const _hoisted_41 = { class: "text-center" }
const _hoisted_42 = { class: "text-center" }
const _hoisted_43 = { class: "text-center" }
const _hoisted_44 = { class: "text-center" }
const _hoisted_45 = { class: "text-center" }
const _hoisted_46 = { class: "text-center" }
const _hoisted_47 = { class: "text-center" }
const _hoisted_48 = { class: "text-center" }
const _hoisted_49 = { class: "text-center" }
const _hoisted_50 = { class: "text-center" }
const _hoisted_51 = { class: "text-center" }
const _hoisted_52 = { class: "text-center" }
const _hoisted_53 = { class: "text-center" }
const _hoisted_54 = { class: "text-center" }
const _hoisted_55 = { class: "text-center" }
const _hoisted_56 = { class: "text-center" }
const _hoisted_57 = { class: "text-center" }
const _hoisted_58 = { class: "text-center" }
const _hoisted_59 = { class: "text-center" }
const _hoisted_60 = { class: "text-center" }
const _hoisted_61 = { class: "text-center" }
const _hoisted_62 = { class: "text-center" }
const _hoisted_63 = { class: "text-center" }
const _hoisted_64 = { class: "text-center" }
const _hoisted_65 = { class: "text-center" }
const _hoisted_66 = { class: "text-center" }
const _hoisted_67 = { class: "text-center" }
const _hoisted_68 = { class: "text-center" }
const _hoisted_69 = { class: "text-center" }
const _hoisted_70 = { class: "text-center" }
const _hoisted_71 = { class: "text-center" }
const _hoisted_72 = { class: "text-center" }
const _hoisted_73 = {
  class: "text-center",
  style: {"white-space":"nowrap"}
}
const _hoisted_74 = { class: "text-center" }
const _hoisted_75 = { class: "text-center" }
const _hoisted_76 = { class: "text-center" }
const _hoisted_77 = { class: "text-center" }
const _hoisted_78 = { class: "text-center" }
const _hoisted_79 = { class: "text-center" }
const _hoisted_80 = { class: "text-center" }
const _hoisted_81 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackPreviousPage = _resolveComponent("BackPreviousPage")
  const _component_UserInformationTimeCard = _resolveComponent("UserInformationTimeCard")
  const _component_MonthPicker = _resolveComponent("MonthPicker")
  const _component_Button = _resolveComponent("Button")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Table = _resolveComponent("Table")
  const _component_PopupAttendance = _resolveComponent("PopupAttendance")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.ppEmployeeId)
        ? (_openBlock(), _createBlock(_component_BackPreviousPage, {
            key: 0,
            onClick: _ctx.goToBack
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_UserInformationTimeCard, {
        "detail-time-card-monthly": _ctx.detailTimeCardMonthly,
        "total-time-over": _ctx.detailTimeCardMonthly.total_speacial_overtime
      }, null, 8, ["detail-time-card-monthly", "total-time-over"]),
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.formatDateTime(_ctx.startDateDailyAttendance).substr(
            0,
            _ctx.formatDateTime(_ctx.startDateDailyAttendance).length - 3
          )), 1),
          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.formatDateTime(_ctx.startDateDailyAttendance).substr(-3, 3)), 1),
          _hoisted_5,
          _createTextVNode(" " + _toDisplayString(_ctx.formatDateTime(_ctx.endDateDailyAttendance).substr(
            0,
            _ctx.formatDateTime(_ctx.endDateDailyAttendance).length - 3
          )), 1),
          _createVNode("span", _hoisted_6, _toDisplayString(_ctx.formatDateTime(_ctx.endDateDailyAttendance).substr(-3, 3)), 1)
        ]),
        _createVNode("div", _hoisted_7, _toDisplayString(_ctx.t('timeCardNew.targetMonth')), 1),
        _createVNode(_component_MonthPicker, {
          width: "120",
          modelValue: _ctx.monthSearch,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.monthSearch = $event)),
          type: "month",
          "is-icon-chevron-left": "",
          "is-icon-chevron-right": "",
          required: "",
          class: "relative"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_8, [
        _withDirectives(_createVNode(_component_Button, {
          class: "btn-disabled-setting font-size-14 mr-8",
          onClick: _ctx.openPopupAttendance
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('displayItemSettings')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]), [
          [_vShow, false]
        ]),
        _createVNode(_component_Button, {
          class: "font-size-14 mr-8",
          onClick: _ctx.calculateTimeKeeping
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('recalculate')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Checkbox, {
          modelValue: _ctx.isConfirmTimeCard,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isConfirmTimeCard = $event)),
          label: _ctx.t('timeCardNew.collectiveIdentity')
        }, null, 8, ["modelValue", "label"])
      ]),
      _createVNode(_component_Table, {
        class: "text-center",
        headers: _ctx.headerTableTimeCard,
        data: _ctx.dailyAttendanceList,
        loading: _ctx.loading,
        "fixed-left": _ctx.ppEmployeeId ? 1 : 2,
        isFixed: true,
        truncateHeaderClass: 'truncate-2-line',
        initMaxHeight: 700
      }, _createSlots({
        "data-date": _withCtx(({ item, dataRow }) => [
          _createVNode("div", {
            style: { color: _ctx.getColorDate(dataRow) },
            class: "text-center"
          }, _toDisplayString(_ctx.displayDate(item)), 5)
        ]),
        "data-shift_pattern_id": _withCtx(({ index }) => [
          _createVNode("div", {
            class: "truncate",
            style: {"text-align":"left"},
            innerHTML: 
            _ctx.handleItemTimeCard(
              _ctx.dailyAttendanceList[index].daily_work_schedule_type,
              _ctx.dailyAttendanceList[index].daily_work_schedule_work_time,
              _ctx.dailyAttendanceList[index].daily_work_schedule_name
            )
          
          }, null, 8, ["innerHTML"])
        ]),
        "data-check_in_time_rounding": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_10, _toDisplayString(_ctx.displayTime(item, 'HH : mm')), 1)
        ]),
        "data-check_out_time_rounding": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_11, _toDisplayString(_ctx.displayTime(item, 'HH : mm')), 1)
        ]),
        "data-check_in_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_12, _toDisplayString(_ctx.displayTime(item, 'HH : mm')), 1)
        ]),
        "data-check_out_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_13, _toDisplayString(_ctx.displayTime(item, 'HH : mm')), 1)
        ]),
        "data-break_start_time_rounding": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_14, _toDisplayString(_ctx.displayTime(item, 'HH : mm')), 1)
        ]),
        "data-break_end_time_rounding": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_15, _toDisplayString(_ctx.displayTime(item, 'HH : mm')), 1)
        ]),
        "data-break_start_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_16, _toDisplayString(_ctx.displayTime(item, 'HH : mm')), 1)
        ]),
        "data-break_end_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_17, _toDisplayString(_ctx.displayTime(item, 'HH : mm')), 1)
        ]),
        "data-statutory_outside_of_working_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_18, _toDisplayString(_ctx.convertNumberToDateTime(item, 'HH : mm')), 1)
        ]),
        "data-time_zone_type_1": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_19, _toDisplayString(_ctx.convertNumberToDateTime(item, 'HH : mm')), 1)
        ]),
        "data-time_zone_type_2": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_20, _toDisplayString(_ctx.convertNumberToDateTime(item, 'HH : mm')), 1)
        ]),
        "data-time_zone_type_3": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_21, _toDisplayString(_ctx.convertNumberToDateTime(item, 'HH : mm')), 1)
        ]),
        "data-time_zone_type_4": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_22, _toDisplayString(_ctx.convertNumberToDateTime(item, 'HH : mm')), 1)
        ]),
        "data-time_zone_type_5": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_23, _toDisplayString(_ctx.convertNumberToDateTime(item, 'HH : mm')), 1)
        ]),
        "data-time_zone_type_6": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_24, _toDisplayString(_ctx.convertNumberToDateTime(item, 'HH : mm')), 1)
        ]),
        "data-time_zone_type_7": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_25, _toDisplayString(_ctx.convertNumberToDateTime(item, 'HH : mm')), 1)
        ]),
        "data-time_zone_type_8": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_26, _toDisplayString(_ctx.convertNumberToDateTime(item, 'HH : mm')), 1)
        ]),
        "data-time_zone_type_9": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_27, _toDisplayString(_ctx.convertNumberToDateTime(item, 'HH : mm')), 1)
        ]),
        "data-time_zone_type_10": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_28, _toDisplayString(_ctx.convertNumberToDateTime(item, 'HH : mm')), 1)
        ]),
        "data-break_start_time_stamp": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_29, _toDisplayString(_ctx.convertNumberToDateTime(item, 'HH : mm')), 1)
        ]),
        "data-midnight_working_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_30, _toDisplayString(_ctx.convertNumberToDateTime(item, 'HH : mm')), 1)
        ]),
        "data-late_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_31, _toDisplayString(_ctx.convertNumberToDateTime(item, 'HH : mm')), 1)
        ]),
        "data-leave_early_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_32, _toDisplayString(_ctx.convertNumberToDateTime(item, 'HH : mm')), 1)
        ]),
        "data-break_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_33, _toDisplayString(_ctx.convertNumberToDateTime(item, 'HH : mm')), 1)
        ]),
        "data-break": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_34, _toDisplayString(_ctx.convertNumberToDateTime(item, 'HH : mm')), 1)
        ]),
        "data-total_work_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_35, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-overtime": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_36, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-working_schedule_within_break_start_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_37, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-paid_deemed_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_38, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-working_schedule_working_time_without_break": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_39, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-working_schedule_break_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_40, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-working_schedule_working_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_41, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-working_schedule_working_total_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_42, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-working_schedule_within_break_end_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_43, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-prescribed_working_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_44, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-prescribed_outside_of_working_time_capacity": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_45, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-prescribed_outside_of_working_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_46, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-prescribed_outside_of_break_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_47, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-prescribed_outside_of_go_out_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_48, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-statutory_outside_of_working_time_with_minus": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_49, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-midnight_working_start_time_setting": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_50, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-midnight_working_end_time_setting": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_51, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-midnight_working_total_break_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_52, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-midnight_working_time_with_minus": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_53, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-midnight_prescribed_working_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_54, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-midnight_outside_prescribed_working_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_55, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-midnight_non_statutory_working_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_56, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-prescribed_holiday_working_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_57, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-prescribed_holiday_prescribed_working_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_58, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-prescribed_holiday_outside_prescribed_working_time": _withCtx(({
          item,
        }) => [
          _createVNode("div", _hoisted_59, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-prescribed_holiday_non_statutory_working_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_60, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-other_go_out_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_61, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-other_break_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_62, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-statutory_holiday_midnight_non_statutory_working_time": _withCtx(({
          item,
        }) => [
          _createVNode("div", _hoisted_63, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-statutory_holiday_midnight_outside_prescribed_working_time": _withCtx(({
          item,
        }) => [
          _createVNode("div", _hoisted_64, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-statutory_holiday_non_statutory_working_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_65, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-statutory_holiday_midnight_working_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_66, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-prescribed_holiday_midnight_working_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_67, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-statutory_holiday_outside_prescribed_working_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_68, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-statutory_holiday_working_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_69, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-statutory_holiday_prescribed_working_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_70, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-prescribed_holiday_midnight_non_statutory_working_time": _withCtx(({
          item,
        }) => [
          _createVNode("div", _hoisted_71, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-prescribed_holiday_midnight_outside_prescribed_working_time": _withCtx(({
          item,
        }) => [
          _createVNode("div", _hoisted_72, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-work_schedule": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_73, _toDisplayString(_ctx.displayWorkingSchedule(item)), 1)
        ]),
        "data-night_working_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_74, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-total_late_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_75, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-total_leave_early_time": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_76, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-minute_statutory_overtime": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_77, _toDisplayString(item
              ? _ctx.convertNumberToDateTime(item, 'H : mm')
              : _ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-minute_non_statutory_overtime": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_78, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-total_minute_statutory_working": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_79, _toDisplayString(_ctx.convertNumberToDateTime(item, 'H : mm')), 1)
        ]),
        "data-final_confirmation": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_80, [
            _createVNode(_component_Checkbox, {
              disabled: "",
              classes: "justify-center",
              value: item,
              modelValue: item.final_confirmation,
              "onUpdate:modelValue": ($event: any) => (item.final_confirmation = $event)
            }, null, 8, ["value", "modelValue", "onUpdate:modelValue"])
          ])
        ]),
        "data-self_confirmation": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_81, [
            _createVNode(_component_Checkbox, {
              disabled: "",
              classes: "justify-center",
              value: item,
              modelValue: item.self_confirmation,
              "onUpdate:modelValue": ($event: any) => (item.self_confirmation = $event)
            }, null, 8, ["value", "modelValue", "onUpdate:modelValue"])
          ])
        ]),
        _: 2
      }, [
        (!_ctx.ppEmployeeId)
          ? {
              name: "data-application",
              fn: _withCtx(({ index }) => [
                _createVNode("div", _hoisted_9, [
                  _createVNode(_component_Dropdown, {
                    itemText: "application_define_name",
                    "item-value": "id",
                    "options-select": _ctx.appFormDefines,
                    placeholder: _ctx.t('dailyAttendanceHeaders.apply'),
                    "onUpdate:modelValue": (e) => _ctx.handleSelectTimeCard(e, index),
                    colorIcon: "#fff",
                    isFixed: "",
                    heightToAlwayBot: (index + 1) * 48
                  }, null, 8, ["options-select", "placeholder", "onUpdate:modelValue", "heightToAlwayBot"])
                ])
              ])
            }
          : undefined
      ]), 1032, ["headers", "data", "loading", "fixed-left"])
    ]),
    _createVNode(_component_PopupAttendance, {
      modelValue: _ctx.isShowPopupAttendance,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowPopupAttendance = $event)),
      onOnClose: _ctx.closePopupAttendance,
      viewTimeCardDefine: _ctx.viewTimeCardDefine,
      viewTimeCardSelected: _ctx.viewTimeCardSelected
    }, null, 8, ["modelValue", "onOnClose", "viewTimeCardDefine", "viewTimeCardSelected"])
  ], 64))
}